var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Topbar'),_c('Navigation'),_c('router-view'),_c('Test')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }